var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full relative"},[_c('O3DSprite',[_c('Portal',{attrs:{"width":_vm.screen.min,"height":_vm.screen.min,"baseResolution":768}},[_c('Flame',{attrs:{"pz":-150}})],1)],1),(_vm.ctx.renderer)?_c('Bloomer',{attrs:{"settings":{
    exposure: 1.0,
    bloomStrength: 1.7,
    bloomThreshold: 12.72 / 100.0,
    bloomRadius: 72.99 / 100.0 * 2
  }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }